<template>
    <div class="w-full flex flex-col items-center justify-center text-center px-8 py-16">
        <div class="w-16 h-16 rounded-full bg-orange-50 flex items-center justify-center mb-4">
            <i class="pi pi-lock text-2xl text-orange-400"></i>
        </div>
        <p class="text-sm font-semibold text-blueGray-500">
            Access restricted
        </p>
        <p class="text-xs text-blueGray-400 mt-2">
            You do not have permission to view {{ title || 'this content' }}.
        </p>
    </div>
</template>

<script>
export default {
    props: ['title']
}
</script>
